import { Modal, Button } from 'react-bootstrap';
import { useState, useEffect, useContext } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom";
import { Input, TextArea, Select, TextAreaAdvanced } from "../../../../../Layout/Forms/Form";
import { TwitterPicker } from 'react-color';
import VipTablesRequests from '../VipTablesRequests';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Slider from '@mui/material/Slider';
import '../../../../Events/form/_FormTable.css'; // Importing shared styles

function FormTables({ show, handleModalShow, handleModalhide, id }) {
    let params = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState({
        form: {
            id: 0,
            name: '',
            color: '#ea2c61',
            numberOfGuests: '',
            base_price: '',
            percentage_pre_payment: 100
        },
        showColorPicker: false,
        errors: [],
    });

    const theme = createTheme({
        components: {
            MuiSlider: {
                styleOverrides: {
                    markLabel: {
                        color: 'rgba(255,255,255,0.5)',
                        fontSize: '0.9rem'
                    },
                    markLabelActive: {
                        color: '#fff',
                        fontWeight: 'bold'
                    },
                    thumb: {
                        width: 24,
                        height: 24
                    }
                },
            },
        },
        palette: {
            primary: {
                main: "#ea2c61",
            },
            secondary: {
                main: '#11cb5f',
            }
        }
    });

    const marksPercentagePrePayment = [
        { value: 0, label: '0' },
        { value: 25, label: '25' },
        { value: 50, label: '50' },
        { value: 75, label: '75' },
        { value: 100, label: '100' },
    ];


    useEffect(async () => {
        if (show) {
            let info = await VipTablesRequests.getTable({ id_venues: params.id, id: id });
            if (info && info.status) {
                setState({
                    ...state,
                    form: info.data
                })
            }
        }
    }, [show])



    const handleSubmitForm = async () => {
        let info = await VipTablesRequests.postTable({ ...state.form, id_venues: params.id });
        if (info && info.status) {
            handleModalhide(false);
            toast.success("A mesa foi registado com sucesso", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
        } else {
            setState({
                ...state,
                errors: info.errors
            })
        }
    }

    const handleChangeInputs = (e) => {
        if (!isLoading) {
            setState({
                ...state,
                form: {
                    ...state.form,
                    [e.target.name]: e.target.value
                }
            });
        }
    }


    const InputColorPicker = () => {
        if (state.showColorPicker) {
            return (
                <div className="form-tables-colorpicker-popover">
                    <div className="form-tables-colorpicker-cover" onClick={() => setState({
                        ...state,
                        showColorPicker: false
                    })} />
                    <TwitterPicker
                        onChangeComplete={handleChangeColorPicker}
                    />
                </div>
            )
        }
        return null;
    }

    const handleChangeColorPicker = (color, event) => {
        setState({
            ...state,
            form: {
                ...state.form,
                color: color.hex
            },
            showColorPicker: false
        })
    };



    return (
        <>
            <Modal show={show} onHide={handleModalhide} contentClassName="glass-modal">
                <Modal.Header>
                    <Modal.Title>Adicionar Mesa</Modal.Title>
                </Modal.Header>

                <Modal.Body className="bg-dark text-white p-4">
                    <div className="animate-fade-in">
                        <h5 className="text-white-50 mb-3 text-uppercase fs-6 ls-1">Informação Básica</h5>
                        <div className="row g-4 mb-4">
                            <div className="col-md-8">
                                <Input
                                    label="Nome da Mesa"
                                    name="name"
                                    value={state.form.name}
                                    onChange={(e) => handleChangeInputs(e)}
                                    type="text"
                                    placeholder="Ex: Mesa VIP Lounge"
                                    errors={state.errors}
                                    className="form-control form-input form-control-lg bg-dark-2 border-dark-3 text-white"
                                />
                            </div>
                            <div className="col-md-4">
                                <label className="form-label text-white fw-bold mb-2">Cor de Destaque</label>
                                <div className="position-relative h-100">
                                    <button
                                        className="btn w-100 d-flex align-items-center justify-content-between p-3 border-0 transition-hover"
                                        style={{
                                            backgroundColor: state.form.color || '#333',
                                            color: '#fff',
                                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                                            height: '52px'
                                        }}
                                        onClick={() => setState({ ...state, showColorPicker: true })}
                                    >
                                        <span className="fw-bold text-shadow">
                                            {state.form.color ? state.form.color : 'Cor'}
                                        </span>
                                        <i className="fas fa-palette ms-2"></i>
                                    </button>
                                    <div className="position-relative">
                                        <InputColorPicker />
                                    </div>
                                </div>
                            </div>

                            <div className="col-12">
                                <TextArea
                                    label="Descrição"
                                    name="description"
                                    value={state.form.description}
                                    onChange={(e) => handleChangeInputs(e)}
                                    type="text"
                                    rows="4"
                                    errors={state.errors}
                                    className="form-control form-input bg-dark-2 border-dark-3 text-white"
                                    placeholder="Descreva as características desta mesa..."
                                />
                            </div>
                        </div>

                        <hr className="border-secondary opacity-25 my-4" />

                        <h5 className="text-white-50 mb-3 text-uppercase fs-6 ls-1">Detalhes & Preço</h5>
                        <div className="row g-4">
                            <div className="col-md-6">
                                <Input
                                    label="Capacidade Max."
                                    name="numberOfGuests"
                                    value={state.form.numberOfGuests}
                                    onChange={(e) => handleChangeInputs(e)}
                                    className='form-control form-input bg-dark-2 border-dark-3 text-white text-end'
                                    type="number"
                                    errors={state.errors}
                                    placeholder="0"
                                />
                            </div>
                            <div className="col-md-6">
                                <Input
                                    label="Preço Base (€)"
                                    name="base_price"
                                    value={state.form.base_price}
                                    onChange={(e) => handleChangeInputs(e)}
                                    className='form-control form-input bg-dark-2 border-dark-3 text-white text-end'
                                    type="number"
                                    errors={state.errors}
                                />
                                <small className="text-muted d-block mt-1 fst-italic">*Pode ser alterado no evento</small>
                            </div>

                            <div className="col-12">
                                <div className="p-4 bg-dark-2 rounded-3 border border-secondary border-opacity-10">
                                    <label className="form-label d-flex justify-content-between mb-2">
                                        <span className="text-white fw-bold">Pré-Pagamento Obrigatório</span>
                                        <span className="text-success fw-bold fs-5">{state.form.percentage_pre_payment}%</span>
                                    </label>
                                    <div className="px-3 pt-2">
                                        <ThemeProvider theme={theme}>
                                            <Slider
                                                value={state.form.percentage_pre_payment}
                                                name='percentage_pre_payment'
                                                onChange={handleChangeInputs}
                                                min={0}
                                                max={100}
                                                step={25}
                                                valueLabelDisplay="auto"
                                                marks={marksPercentagePrePayment}
                                            />
                                        </ThemeProvider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer className="bg-dark border-top border-secondary border-opacity-10 p-3">
                    <div className="d-flex justify-content-end w-100 gap-2">
                        <Button variant="link" className="text-white text-decoration-none px-4 py-2" onClick={handleModalhide}>
                            Cancelar
                        </Button>
                        <Button className="btn-action-primary px-5 py-2 fw-bold shadow-lg" onClick={handleSubmitForm}>
                            Guardar Mesa
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default FormTables;